import React, { useEffect, useState } from "react"
import { Loader, Progress } from "rsuite"
import { getGlobalAcceptanceValue, getSupplierCompletenessScore } from "../../../../services/helper";
import { useDispatch } from "react-redux";
const { Circle } = Progress;
const style = {
    width: 50,
    display: 'inline-block',
    marginRight: 10
}

const MasterSupplierHealth = ({ qaStatus, supplierData = null, masterType = 'master' }) => {
    const dispatch = useDispatch()
    const [isLoadingGlobalAcc, setIsLoadingGlobalAcc] = useState(false)
    const [isLoadingCompletenessScore, setIsLoadingCompletenessScore] = useState(false)
    const [globalAcceptance, setGlobalAcceptance] = useState(null)
    const [completenessScore, setCompletenessScore] = useState(0)
    const [confidenceScore, setConfidenceScore] = useState(0)

    useEffect(async () => {
        if (supplierData && Object.keys(supplierData)?.length > 0) {
            setIsLoadingCompletenessScore(true)
            const score = await getSupplierCompletenessScore(supplierData?.baseInfo, supplierData?.cardInfo, supplierData?.paymentInfo, supplierData?.cardEmailsInfo, dispatch)
            setCompletenessScore(score)
            setIsLoadingCompletenessScore(false)
        } else {
            setCompletenessScore(0)
            setIsLoadingCompletenessScore(false)
        }
    }, [supplierData])

    useEffect(async () => {
        if (supplierData && Object.keys(supplierData)?.length > 0) {
            setIsLoadingGlobalAcc(true)
            const globalAcc = await getGlobalAcceptanceValue(supplierData?.cardInfo, supplierData?.baseInfo?.id, dispatch)
            setGlobalAcceptance(globalAcc)
            setIsLoadingGlobalAcc(false)
        } else {
            setGlobalAcceptance('Unknown')
            setIsLoadingGlobalAcc(false)
        }
    }, [supplierData])

    return (
        <div className="dashboard-component p-0 supplier-health">
            <div className="card">
                <div className="card-header">
                    <h3 className='fw-bold'>{masterType === 'master' ? 'Master' : 'Location Master'} Supplier Health</h3>
                </div>
                <div className="dashboard-header card-body p-3 m-0">
                    <div className='row gap-3 gap-xl-5 g-0'>
                        <div className='flex-one col-3 dashboard-card p-4 bg-dark-blue'>
                            <div className='card-left align-items-center flex-grow-1 text-white gap-2 h-100'>
                                {window.innerWidth >= 1400 ?
                                    <h2 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>Global Acceptance:</h2>
                                    :
                                    (window.innerWidth > 991 && window.innerWidth < 1400) ?
                                        <h3 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>Global Acceptance:</h3>
                                        :
                                        <h4 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>Global Acceptance:</h4>
                                }
                                {isLoadingGlobalAcc ? <Loader className="mb-3 align-self-end" size='md' /> :
                                    <>
                                        <h3 className='fw-bold text-white text-end mb-0 align-self-end'>{globalAcceptance}</h3>
                                    </>
                                }
                            </div>
                        </div>
                        <div className='flex-one col-3 dashboard-card p-4 bg-dark-blue'>
                            <div className='card-left align-items-center flex-grow-1 text-white gap-2 h-100'>
                                {window.innerWidth >= 1400 ?
                                    <h2 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>QA Status:</h2>
                                    :
                                    (window.innerWidth > 991 && window.innerWidth < 1400) ?
                                        <h3 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>QA Status:</h3>
                                        :
                                        <h4 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>QA Status:</h4>
                                }
                                <>
                                    <h3 className={`fw-bold text-end mb-0 align-self-end${qaStatus ? (qaStatus === 'In Calls' ? ' text-light-blue' : qaStatus === 'Rejected' ? ' text-red' : qaStatus === 'Approved' ? ' text-green' : ' text-yellow') : ' fs-0 text-white'}`}>{qaStatus ? qaStatus : <Loader className="mb-3" size="md" />}</h3>
                                </>
                            </div>
                        </div>
                        <div className='flex-one col-3 dashboard-card p-4 bg-dark-blue'>
                            <div className='card-left align-items-center flex-grow-1 text-white gap-2 h-100'>
                                {window.innerWidth >= 1400 ?
                                    <h2 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>Completeness Score:</h2>
                                    :
                                    (window.innerWidth > 991 && window.innerWidth < 1400) ?
                                        <h3 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>Completeness Score:</h3>
                                        :
                                        <h4 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>Completeness Score:</h4>
                                }
                                <div className='text-white text-end mb-0 align-self-end' style={style}>
                                    {isLoadingCompletenessScore ? <Loader className="mb-3 align-self-end" size='md' />
                                        :
                                        <Circle percent={completenessScore} strokeColor="#4184B1" strokeWidth={10} />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='flex-one col-3 dashboard-card p-4 bg-dark-blue'>
                            <div className='card-left align-items-center flex-grow-1 text-white gap-2 h-100'>
                                {window.innerWidth >= 1400 ?
                                    <h2 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>Confidence Score:</h2>
                                    :
                                    (window.innerWidth > 991 && window.innerWidth < 1400) ?
                                        <h3 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>Confidence Score:</h3>
                                        :
                                        <h4 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>Confidence Score:</h4>
                                }
                                <div className='text-white text-end mb-0 align-self-end' style={style}>
                                    <Circle className="text-white" percent={confidenceScore} strokeColor="#4184B1" strokeWidth={10} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MasterSupplierHealth